/*
 * @Description: 
 * @Version: 1.0
 * @Autor: zhangle
 * @Date: 2022-03-16 13:43:35
 * @LastEditors: zhangle
 * @LastEditTime: 2023-04-23 14:31:48
 */
import TsaAgreement from '@/components/Agreement/index.vue'
let $vm
let watcher
let watcher1
const plugin = {
  install (vue, pluginOptions = {}) {
    const Agreement = vue.extend(TsaAgreement)
    if (!$vm) {
      $vm = new Agreement({
        el: document.createElement('div')
      })
      document.body.appendChild($vm.$el)
    }

    const agreement = {
      show (options = {}) {
        // destroy watcher
        watcher && watcher()
        watcher = $vm.$watch('statusConfirm', (val) => {
            val && options.onConfirm && options.onConfirm()
          })
          watcher1 && watcher1()
          watcher1 = $vm.$watch('statusCancel', (val) => {
            val && options.onCancel && options.onCancel()
          })
          $vm.show = true
          $vm.title = options.title
          $vm.url = options.url
      },
      hide () {
        $vm.show = false
      }
    }
    if (!vue.prototype.$TsaAgreement) {
      vue.prototype.$TsaAgreement = agreement
    }
  }
}

export default plugin



// WEBPACK FOOTER //
// ./src/plugins/Agreement/index.js